import { tokenRedirectUri } from 'root/src/shared/constants/pageData'
import compose from 'ramda/src/compose'
import { authApiBase } from 'root/src/shared/constants/auth'

export default (platform, token, state = {}, redirectUrl = tokenRedirectUri) => {
	const prepJsonUri = compose(encodeURIComponent, JSON.stringify)
	const prepState = statePayload => prepJsonUri({ token, ...statePayload })
	const stateEncoded = prepState({ token, redirectUrl, ...state })
	return `${authApiBase}/sign-in/${platform}?state=${stateEncoded}`
}
